import Router from "next/router";

const getUserAgent = (ctx) => {
  if (ctx?.req) {
    return ctx.req.headers["user-agent"] ?? "";
  }
  if (process.browser) {
    return navigator.userAgent;
  }
  return "";
};

export const ctxIsApp = (ctx = null) => getUserAgent(ctx).includes("penfold");

export const getAppVersion = (ctx) => {
  const match = getUserAgent(ctx).match(/penfold (\d\.\d+\.\d+)/);
  return match?.[1];
};

// TODO: report to sentry
export const bindAppRouteWarning = () => {
  const ROUTE_CHANGE_LIMIT = 100;
  if (!ctxIsApp()) {
    return;
  }

  let lastStart = null;
  const checkRouteChange = () => {
    if (new Date() - lastStart > ROUTE_CHANGE_LIMIT) {
      console.warn(
        `Route took over ${ROUTE_CHANGE_LIMIT}ms to complete. Please add ${window.location.pathname} to pages/app/launch.js`
      );
    }
  };

  Router.events.on("routeChangeStart", () => {
    lastStart = new Date();
  });
  Router.events.on("routeChangeComplete", checkRouteChange);
  Router.events.on("routeChangeError", checkRouteChange);
};

export const bindInstallPrompt = () => {
  window.addEventListener("beforeinstallprompt", (event) => {
    // If we wanted to use our own custom prompt we would call event.preventDefault() and later event.prompt()

    event.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        window.analytics.track("App install prompt accepted");
      } else {
        window.analytics.track("App install prompt dismissed");
      }
    });
  });
};

export const IS_IN_APP_BROWSER_SEARCH_PARAM = "_is_in_app_browser";
